import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { Logo } from "@/components/site/Logo";
import { EMAIL, PHONE, PHONE_HREF } from "@/lib/api";
import { RotatingLogo } from "@/components/site/RotatingLogo";

export const Footer = () => (
  <footer className="relative overflow-hidden bg-[#050B1F] px-4 pb-10 pt-20 text-white sm:px-6 lg:px-12" data-testid="site-footer">
    <div className="mx-auto max-w-7xl">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo light />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-emerald-100/80">
            Payment processing that helps your business grow. Fewer fees, better equipment, and people who pick up the phone.
          </p>
          <div className="mt-6 flex flex-col gap-3">
            <a href={PHONE_HREF} data-testid="footer-phone-link" className="inline-flex items-center gap-2 font-display text-xl font-bold text-white hover:text-lime-300">
              <Phone className="h-4 w-4 text-lime-300" /> {PHONE}
            </a>
            <a href={`mailto:${EMAIL}`} data-testid="footer-email-link" className="inline-flex items-center gap-2 text-lime-300 hover:text-lime-200">
              <Mail className="h-4 w-4" /> {EMAIL}
            </a>
          </div>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-emerald-300">Explore</p>
          <ul className="mt-4 space-y-2 text-emerald-50">
            {[["/", "Home"], ["/solutions", "Solutions"], ["/support", "Support"], ["/about", "About"], ["/contact", "Contact"], ["/sign-in", "Sign In"]].map(([to, l]) => (
              <li key={to}><Link to={to} data-testid={`footer-link-${l.toLowerCase().replace(" ", "-")}`} className="hover:text-lime-300">{l}</Link></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-emerald-300">The fine print</p>
          <p className="mt-4 text-sm leading-relaxed text-emerald-100/80">
            Free equipment is available to qualifying merchants. Fee elimination programs depend on business type and setup. Ask your account manager for details.
          </p>
        </div>
      </div>
      <div className="mt-16 flex items-end justify-between gap-6">
        <p className="pointer-events-none select-none font-display text-[18vw] font-extrabold leading-[0.8] tracking-tighter text-white/[0.06] lg:text-[13rem]">zero.</p>
        <RotatingLogo size={110} ring={false} testid="footer-rotating-logo" className="mb-2 hidden shrink-0 sm:block" />
      </div>
      <div className="mt-6 flex flex-col justify-between gap-2 border-t border-white/10 pt-6 text-xs text-emerald-200/70 sm:flex-row">
        <span>© 2026 866Zerofees.com. All rights reserved.</span>
        <span className="font-mono">Zero fees. Real people.</span>
      </div>
    </div>
  </footer>
);
